(() => {
  const initRichTextDateTimes = (root = document) => {
    root.querySelectorAll('rich-text-datetime').forEach((el) => {
      if (typeof el.refresh === 'function') el.refresh();
    });
  };

  class RichTextDateTime extends HTMLElement {
    static get observedAttributes() {
      return ['data-format'];
    }

    connectedCallback() {
      this.locale = this.lang || document.documentElement.lang || 'en';
      this.refresh();
      if (this.timer) window.clearInterval(this.timer);
      this.timer = window.setInterval(() => this.refresh(), 30000);
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    attributeChangedCallback() {
      if (this.isConnected) this.refresh();
    }

    refresh() {
      this.format = this.dataset.format || 'full';
      const now = new Date();
      const time = new Intl.DateTimeFormat(this.locale, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).format(now);

      if (this.format === 'compact') {
        const day = new Intl.DateTimeFormat(this.locale, { day: 'numeric' }).format(now);
        const month = new Intl.DateTimeFormat(this.locale, { month: 'short' }).format(now).toUpperCase();
        const year = new Intl.DateTimeFormat(this.locale, { year: 'numeric' }).format(now);
        this.textContent = `${day} ${month} ${year} · ${time}`;
        return;
      }

      const date = new Intl.DateTimeFormat(this.locale, {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      }).format(now);

      this.textContent = `${date.toUpperCase()} · ${time}`;
    }
  }

  if (!customElements.get('rich-text-datetime')) {
    customElements.define('rich-text-datetime', RichTextDateTime);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initRichTextDateTimes(event.target);
  });

  document.addEventListener('DOMContentLoaded', () => {
    initRichTextDateTimes();
  });
})();
